function getLocationSnapshot() {
  if (typeof window === 'undefined') {
    return {
      protocol: 'https:',
      hostname: 'heyi.co.il',
      port: '',
      pathname: '/',
      search: '',
      hash: '',
      origin: 'https://heyi.co.il',
      href: 'https://heyi.co.il/',
    };
  }

  return window.location;
}

function getNormalizedTarget(targetPath = '/') {
  const location = getLocationSnapshot();
  const fallbackPath = `${location.pathname || '/'}${location.search || ''}${location.hash || ''}`;
  const rawTarget = targetPath || fallbackPath;
  const normalizedInput = rawTarget.startsWith('/') ? rawTarget : `/${rawTarget}`;
  const parsedTarget = new URL(normalizedInput, location.origin);

  return {
    pathname: parsedTarget.pathname,
    search: parsedTarget.search,
    hash: parsedTarget.hash,
  };
}

export function getCurrentHref() {
  return getLocationSnapshot().href;
}

export function getCurrentOrigin() {
  return getLocationSnapshot().origin;
}

export function isKidsHost(hostname = getLocationSnapshot().hostname) {
  return hostname.startsWith('kids.');
}

export function getBaseHostname(hostname = getLocationSnapshot().hostname) {
  return hostname.replace(/^(kids|events)\./, '');
}

export function buildProductUrl(product, path = `${getLocationSnapshot().pathname}${getLocationSnapshot().search}${getLocationSnapshot().hash}`) {
  const location = getLocationSnapshot();
  const baseHostname = getBaseHostname(location.hostname);
  const targetHostname = `${product}.${baseHostname}`;
  const portSegment = location.port ? `:${location.port}` : '';
  const target = getNormalizedTarget(path);

  return `${location.protocol}//${targetHostname}${portSegment}${target.pathname}${target.search}${target.hash}`;
}

export function redirectToProduct(product, path = `${getLocationSnapshot().pathname}${getLocationSnapshot().search}${getLocationSnapshot().hash}`) {
  try {
    const target = buildProductUrl(product, path);
    const currentHref = getCurrentHref();

    if (currentHref.includes(target)) {
      console.warn('[REDIRECT LOOP PREVENTED]', target);
      return;
    }

    console.warn('[REDIRECT]', {
      from: currentHref,
      to: target,
    });

    window.location.assign(target);
  } catch (err) {
    console.error('[REDIRECT FAILED]', err);
  }
}
